<template>
  <div class="peers flex d-flex flex-column justify-end">
    <!-- <GlobalEvents
      target="window"
      @paste="_onPaste"
    ></GlobalEvents> -->

    <div class="flex d-flex flex-column justify-center">
      <div v-if="!peers.length" class="no-peers text-center px-2 py-4 w-100">
        <h2 v-if="!room || room.id === 'local'" class="font-weight-500 d-inline-block">
          Öffne <strong>XIDRAS</strong><i>Transfer</i> auf anderen Geräten in deinem Netzwerk um Dateien auszutauschen.
        </h2>
        <template v-else-if="room">
          <h2 class="font-weight-500 d-inline-block">
            Öffne diesen <strong>XIDRAS</strong><i>Transfer</i>-Raum auf anderen Geräten um Dateien auszutauschen.
          </h2><br>
          <v-btn
            v-if="canInviteUsers"
            color="accent"
            class="mt-4"
            depressed
            @click.prevent="$parent.$refs.roomInviteUser.show()"
          >
            <v-icon class="mr-2">far fa-user-plus</v-icon>
            Benutzer einladen
          </v-btn>
        </template>
      </div>
    </div>

    <div
      v-for="row in grid"
      :key="row.index"
      class="peers-row d-flex flex-row justify-center align-end w-100"
      :peers-row="row.index + 1"
    >
      <div
        v-for="column in row.columns"
        :key="column.index"
        class="peer-col"
        :class="{'order-first': column.index + 1 === columnsPerRow}"
        :peer-col="column.index + 1"
      >
        <Peer v-if="column.peer" :peer="column.peer" />
      </div>
    </div>

    <div v-if="peers.length" class="instructions font-weight-500 text-center w-100">
      <span v-if="!isTouchDevice" class="d-inline-block">
        Klicke auf ein Gerät um Dateien zu versenden.<br>
        Rechtsklick auf ein Gerät um Nachrichten zu versenden.
      </span>
      <span v-else class="d-inline-block">
        Tippe auf ein Gerät um Dateien zu versenden.<br>
        Tippe lange auf ein Gerät um Nachrichten zu versenden.
      </span>
    </div>
  </div>
</template>

<script>
  // import GlobalEvents from 'vue-global-events';
  import Peer from './Peer';
  import {isTouchDevice, canInviteUsers} from '../../assets/js/utils';


  export default {
    name: 'Peers',

    components: {
      // GlobalEvents,
      Peer
    },

    data() {
      return {
        columnsPerRow: 3,
        isTouchDevice
      };
    },

    computed: {
      peers() {
        let peers = [...this.$store.getters['share/getPeers']];
        if (this.$store.getters['share/getTour']?.examplePeer) {
          peers.unshift({
            id: 'example',
            name: {
              browser: '',
              os: 'Beispielgerät',
              type: 'mobile',
              userName: 'Max Mustermann'
            },
            candidateTypes: {local: 'host', remote: 'host'}
          });
        }
        return peers;
      },

      room() {
        return this.$store.getters['share/getRoom'];
      },

      grid() {
        const {peers, columnsPerRow} = this;
        let rowsCount = Math.ceil(peers.length / columnsPerRow);

        const getIndex = (rowIndex, columnIndex) => {
          const offset = (rowIndex + 1) * columnsPerRow - columnsPerRow;
          return offset + columnIndex;
        };

        const arrayOfIndexes = (length) => [...Array(length).keys()];

        const rows = arrayOfIndexes(rowsCount).map((rowIndex) => ({
          index: rowIndex,
          columns: arrayOfIndexes(columnsPerRow).map((columnIndex) => ({
            index: columnIndex,
            peer: peers[getIndex(rowIndex, columnIndex)]
          }))
        }));

        // Show rows from bottom to top.
        rows.reverse();

        return rows;
      },

      canInviteUsers() {
        return canInviteUsers(this.room);
      }
    },

    methods: {
      // _onPaste(e) {
      //   const files = e.clipboardData.files || e.clipboardData.items
      //     .filter((i) => i.type.indexOf('image') > -1)
      //     .map((i) => i.getAsFile());
      //   const peers = document.querySelectorAll('.x-peer');
      //   // send the pasted image content to the only peer if there is one
      //   // otherwise, select the peer somehow by notifying the client that
      //   // "image data has been pasted, click the client to which to send it"
      //   // not implemented
      //   if (files.length > 0 && peers.length === 1) {
      //     eventBus.$emit('files-selected', {
      //       files: files,
      //       to: $$('.x-peer').id
      //     });
      //   }
      // }
    }
  };
</script>
